import { render, staticRenderFns } from "./marques-data.vue?vue&type=template&id=7d9ceaf8"
import script from "./marques-data.vue?vue&type=script&lang=js"
export * from "./marques-data.vue?vue&type=script&lang=js"
import style0 from "./marques-data.vue?vue&type=style&index=0&id=7d9ceaf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports